"use client";

import AnimatedBackground from "@/components/sections/auth/animatedBackground";

interface LayoutAdminProps {
  children: React.ReactNode;
}

const LayoutAuth = ({ children }: LayoutAdminProps) => {
  return (
    <div className="relative min-h-screen">
      <AnimatedBackground />
      <main className="z-10 flex flex-col min-h-screen items-center justify-center">
        {children}
      </main>
    </div>
  );
};

export default LayoutAuth;
